var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import clsx from 'clsx';
import { CardLink } from '@otp/icons';
import styles from './card.module.css';
export const Card = (_a) => {
    var { className, isLink, linkPosition = 'bottom', withoutLinkIcon, onClick, children, noBorder, padding = 4, linkIconClassName } = _a, props = __rest(_a, ["className", "isLink", "linkPosition", "withoutLinkIcon", "onClick", "children", "noBorder", "padding", "linkIconClassName"]);
    const linkIconPositionStyle = linkPosition === 'top' ? styles.linkIconTop : styles.linkIconBottom;
    return (_jsxs(Box, Object.assign({}, props, { sx: Object.assign({ p: padding }, props.sx), className: clsx(className, styles.wrapper, {
            [styles.wrapperPointer]: !!isLink,
            [styles.noBorder]: !!noBorder,
        }), onClick: onClick, children: [children, !withoutLinkIcon && isLink && (_jsx(CardLink, { className: clsx(styles.linkIcon, linkIconPositionStyle, linkIconClassName) }))] })));
};
export default Card;
